import React from "react";
import { UserProvider } from "./user/userContext";
import { CartProvider } from "./cart/cartContext";

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <UserProvider>
      <CartProvider>{children}</CartProvider>
    </UserProvider>
  );
};
